import { React } from "react";
import * as eDepositSelectors from "../../../../selectors/e-deposit";
import clsx from "clsx";
import { Col, Row } from "react-bootstrap";
import CustomEmptyFont from "../../../../components/CustomEmptyFont";

function DepositOnlinePaymentItem({ item }) {
  const reference = eDepositSelectors.getOnlinePaymentReference(item);
  const status = eDepositSelectors.getOnlinePaymentStatusText(item);
  const paymentPaidAtText = eDepositSelectors.getOnlinePaymentPaidAtText(item);
  const amountFullText = eDepositSelectors.getOnlinePaymentAmountFullText(item);
  return (
    <div>
      <div className="d-flex deposit-form-title position-relative">
        <p className="payment-detail-title text-bold-600 mb-0">Online Payment Info</p>
      </div>
      <div className={clsx("deposit-item-container")}>
        <Row className={clsx("gy-3")}>
          <Col xl={6} md={6} xs={12}>
            <h6>Amount</h6>
            <p>{amountFullText}</p>
          </Col>
          <Col xl={6} md={6} xs={12}>
            <h6>Reference</h6>
            <p>{reference}</p>
          </Col>
          <Col xl={6} md={6} xs={12}>
            <h6>Status</h6>
            <p>{status}</p>
          </Col>
          <Col xl={6} md={6} xs={12}>
            <h6>Date/Time</h6>
            <p>{paymentPaidAtText}</p>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default DepositOnlinePaymentItem;
